import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FinanceServicesService {

  constructor(private http: HttpClient, private httpService: HttpService) {

  }
  financeDataRelatedCompany() {
      var request = {
          URL: "financialData/relatedCompany"
          // DATA: comapanyDetailID
      }
      return this.httpService.get(request);
  }  

  getCompanyIncorporationDate() {

      var request = {
          URL: "companyMaster/getIncorporationdate/"        
      }
      return this.httpService.get(request);
  }
}